import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = {
  key: 3,
  class: "fw-700 text-capitalize color-danger-300 fs-lg",
  style: {"position":"relative","top":"-8px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _mergeProps($setup.getRootProps(), { class: "dropzone" }), [
    _createElementVNode("input", _normalizeProps(_guardReactiveProps($setup.getInputProps())), null, 16),
    _createElementVNode("div", {
      class: _normalizeClass(["inner", { isMin: $props.isMinMode }])
    }, [
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fal fa-cloud-upload text-muted mb-3 dzlogo" }, null, -1)),
      (_ctx.isDragReject)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, "3MB以内のPDFファイルを1つドロップしてください"))
        : (_ctx.isDragAccept)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, "そのままドロップしてください ..."))
          : (_openBlock(), _createElementBlock("p", _hoisted_3, "ファイルをドロップするか、クリックして選択 ...")),
      ($setup.isRejected)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " 3MB以内のPDFファイルを1つドロップしてください "))
        : _createCommentVNode("", true)
    ], 2)
  ], 16))
}